 <ng-container [formGroup]='numberRangeFormGroup'>
   <div fxLayout='row' fxLayout.lt-md='column'>
   <mat-form-field class='field-filter number-range' appearance='outline'>
     <mat-label>{{data.options.from.place_holder}}</mat-label>
     <input matInput name="{{data.options.from.key}}" formControlName='{{data.options.from.key}}' type='number' />

   </mat-form-field>
   <mat-form-field class='field-filter number-range' appearance='outline'>
     <mat-label>{{data.options.to.place_holder}}</mat-label>
     <input matInput name="{{data.options.to.key}}" formControlName='{{data.options.to.key}}' type='number' />
   </mat-form-field>
     </div>
 </ng-container>
